import { Dialog, DialogProps } from "../core/components/dialog.js";
import { CheckBox } from "../core/components/checkBox.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { Helper } from "../core/util/helper.js";
import React from "react";
import ReactDOM from "react-dom";

export const openStateDialog = (options: DialogOptions) => {
    return new Promise<DialogResult>((resolve) => {
        const { state, updateKalenderId, updateTimezone } = options;


        if ((Helper.isNullOrEmpty(state.Id)) || (Helper.isNullOrEmpty(state.Timezone) && Helper.hasValue(state.KalenderId)) || (!updateKalenderId && !updateTimezone)) {
            resolve({ updateKalenderId: false, updateTimezone: false });
            return;
        }

        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);


        const removeDialog = () => {
            root.unmount(targetElement[0]);
            targetElement[0].remove();
        }

        const onSelect = (result: DialogResult) => {
            resolve(result)
        }

        root.render(<StateDialog state={state} onSelect={onSelect} updateKalenderId={updateKalenderId} updateTimezone={updateTimezone} />);
    });
}

interface DialogOptions {
    state: State;
    updateTimezone: boolean;
    updateKalenderId: boolean;
}

class StateDialog extends React.Component<StateDialogProps, DialogResult>{
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("WebSMS.Country.TransferData"),
        open: true,
        actions: [
            {
                label: Helper.getTranslation("WebSMS.Country.Update.AdoptNothing"),
                action: () => {
                    this.props.onSelect({
                        updateKalenderId: false,
                        updateTimezone: false
                    })
                },
            },
            {
                label: Helper.getTranslation("WebSMS.Country.Update.AdoptAll"),
                action: () => {
                    this.props.onSelect({
                        updateKalenderId: true,
                        updateTimezone: true
                    })

                }
            },
            {
                label: Helper.getTranslation("WebSMS.Country.Update.AdoptAsSelected"),
                action: () => {
                    this.props.onSelect({
                        updateKalenderId: this.state.updateKalenderId && this.showKalenderIdCB,
                        updateTimezone: this.state.updateTimezone && this.showTimezoneCB
                    })
                },
                primary: true
            }
        ],
        afterClose: () => {},
        width: 675
    };

    private showTimezoneCB: boolean;
    private showKalenderIdCB: boolean;

    constructor(props: StateDialogProps) {
        super(props)
        this.showTimezoneCB = !Helper.isNullOrEmpty(this.props.state.Timezone) && props.updateTimezone;
        this.showKalenderIdCB = Helper.hasValue(this.props.state.KalenderId) && props.updateKalenderId;
        this.state = {
            updateKalenderId: true,
            updateTimezone: true
        }
    }

    private renderCheckbox = (field: keyof (DialogResult)) => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.onChange = (_, value: boolean) => {
            if (field == "updateKalenderId") {
                this.setState({ updateKalenderId: value })
            } else if (field == "updateTimezone") {
                this.setState({ updateTimezone: value })
            }
        }
        props.value = this.state[field]
        let label = Helper.getTranslation(`WebSMS.Country.Update.${field}`)
            .replace('{timezone}', this.props.state.Timezone)
            .replace('{calendar}', this.props.state.KalenderName)
        
        return (
            <div>
                <label>{label}</label>
                <CheckBox {...props} />
            </div>
        );
    }

    render() {
        return (
            <>
                <style>
                    {".checkbox__container{margin: 0; display: flex; align-items: center; justify-content: center}"}
                    {"div[data-role='dialog'] > div{display: flex; align-items: center; padding: 5px}"}
                    {"div[data-role='dialog'] > div > label{margin-right: 15px}"}
                </style>
                <Dialog {...this.dialogProps} >
                    <>
                        {this.showTimezoneCB ? this.renderCheckbox("updateTimezone") : null}
                        {this.showKalenderIdCB ? this.renderCheckbox("updateKalenderId") : null}
                    </>
                </Dialog>
            </>
        );
    }
}

interface StateDialogProps {
    state: State;
    onSelect: (result: DialogResult) => void;
    updateTimezone: boolean;
    updateKalenderId: boolean;
}
interface State {
    Id: string;
    KalenderId: number;
    Timezone: string;
    KalenderName: string;
}

interface DialogResult {
    updateTimezone: boolean;
    updateKalenderId: boolean;
}